import {formatCurrency} from "../util";

export let mixed = {
    default: 'Invalid value',
    required: 'This is a mandatory field',
    oneOf: 'Must match one of the following values: ${values}',
    notOneOf: 'Must not match any of the following values: ${values}',
};

export let string = {
    length: 'Must be exactly ${length} characters long ',
    min: 'Must be at least ${min} characters long',
    max: 'Must be at most ${max} characters long',
    matches: 'Must look like this: "${regex}"',
    email: 'Must contain a valid email address ',
    url: 'Must be a valid url',
    trim: 'Must not contain any spaces at the beginning or end',
    lowercase: 'May only contain lower case letters ',
    uppercase: 'May only contain capitalization',
};

export let number = {
    min: ({min}) => (`Must be greater than or equal to ${formatCurrency(min)}`),
    max: ({max}) => (`Must be less than or equal to ${formatCurrency(max)}`),
    lessThan: ({lessThan}) => (`Must be less than ${formatCurrency(lessThan)}`),
    moreThan: ({moreThan}) => (`Must be greater than ${formatCurrency(moreThan)}`),
    notEqual: ({notEqual}) => (`Must not be the same as ${formatCurrency(notEqual)}`),
    positive: 'Must be a positive number',
    negative: 'Must be a negative number',
    integer: 'Must be a whole number',
};

export let date = {
    min: 'Must be later than ${min}',
    max: 'Must be earlier than ${max}',
};

export let boolean = {};

export let object = {
    noUnknown: 'Field must not use keys that have not been defined',
};

export let array = {
    min: 'Field must have at least ${min} entries',
    max: 'Field can have a maximum of ${max} entries',
};

export default {
    mixed,
    string,
    number,
    date,
    object,
    array,
    boolean,
};
